module.exports = __webpack_public_path__ + "img/main_img3.41e19086.png";